// extracted by mini-css-extract-plugin
module.exports = {"main":"barY_main__XAv4U"};